import { z } from 'zod'
import { parameterdDataSchema } from './parameterd-data'

/**
 * 參數類別 - 新增/更新 Response Schema
 */
export const upsertParametermResponseSchema = parameterdDataSchema

/**
 * 參數類別 - 新增/更新 Response
 */
export interface UpsertParametermResponse
  extends z.infer<typeof upsertParametermResponseSchema> {}
